import { useQuery } from "@tanstack/react-query";
import { Bot } from "lucide-react";
import { useNavigate } from "react-router";
import { Button } from "@/ui";
import { agentActions as agentActionsApi } from "../lib/api";
import { AGENT_ACTIONS_QUERY_KEY } from "../lib/query-keys";

/** Shared with the Agent requests page so both read one cache entry. */
export const agentActionsQuery = {
    queryKey: AGENT_ACTIONS_QUERY_KEY,
    queryFn: agentActionsApi.list,
    refetchInterval: 30_000,
    staleTime: 10_000,
};

/** Header shortcut to the approval queue; only shown while something waits. */
export default function AgentRequestsBadge() {
    const navigate = useNavigate();
    const { data } = useQuery(agentActionsQuery);
    const waiting = data?.data.filter(row => row.status === "pending").length ?? 0;
    if (!waiting) return null;
    return (
        <Button
            variant="ghost"
            size="sm"
            className="icon-button notification-trigger"
            aria-label={`${waiting} agent ${waiting === 1 ? "request" : "requests"} waiting for approval`}
            title="Agent requests"
            onClick={() => navigate("/agent-requests")}
        >
            <Bot /><span className="notification-count">{waiting > 99 ? "99+" : waiting}</span>
        </Button>
    );
}
